'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIStepIndicator from 'UIComponents/connectedStep/UIStepIndicator';
import { ACCOUNT_SETUP_STEPS_TO_DISPLAY } from 'ads-account-connection/lib/AdwordsSetupStatus';
const stepNames = ACCOUNT_SETUP_STEPS_TO_DISPLAY.map(step => /*#__PURE__*/_jsx("strong", {
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.${step}`
  })
}, step));

const AdwordsStepIndicators = ({
  stepIndex
}) => /*#__PURE__*/_jsx(UIGrid, {
  children: /*#__PURE__*/_jsx(UIStepIndicator, {
    direction: "horizontal",
    stepIndex: stepIndex,
    stepNames: stepNames,
    use: "default",
    responsiveBreakpoint: 100
  })
});

export default AdwordsStepIndicators;